import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useDropzone } from 'react-dropzone';
// import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Button,
  IconButton,
  // List,
  // ListItem,
  // ListItemIcon,
  // ListItemText,
  Tooltip,
  Typography,
  makeStyles,
  // Popover,
} from '@material-ui/core';
// import FileCopyIcon from '@material-ui/icons/FileCopy';
// import MoreIcon from '@material-ui/icons/MoreVert';
import { Trash } from 'react-feather';
import { Alert } from '@material-ui/lab';
// import bytesToSize from 'utils/bytesToSize';

const useStyles = makeStyles((theme) => ({
  root: {},
  dropZone: {
    border: `1px dashed ${theme.palette.divider}`,
    padding: theme.spacing(6),
    outline: 'none',
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    marginBotto: 20,
    alignItems: 'center',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      opacity: 0.5,
      cursor: 'pointer',
    },
  },
  dragActive: {
    backgroundColor: theme.palette.action.active,
    opacity: 0.5,
  },
  image: {
    width: 130,
  },
  container: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
  },
  images: {
    width: 140,
    borderRadius: 10,
    padding: 2,
  },
  imageContainer: {
    width: 140,
    position: 'relative',
  },
  button: {
    position: 'absolute',
    top: 2,
    right: 2,
    zIndex: 100,
    backgroundColor: '#F5F5F5',
    borderRadius: 100,
    '&:hover': {
      backgroundColor: '#ECECEC',
    },
  },
  info: {
    marginTop: theme.spacing(1),
  },
  list: {
    maxHeight: 320,
  },
  actions: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-end',
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
  },
  textButton: {
    cursor: 'pointer',
  },
}));

function ImageDropzone({
  className,
  field: {
    name,
  },
  form: {
    setFieldValue,
  },
  accept = '.jpg, .png, .svg, .jpeg',
  limit = 10000,
  ...rest
}) {
  const classes = useStyles();
  const [files, setFiles] = useState([]);
  const [aux, setAux] = useState([]);

  const toBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

  const handleDrop = (acceptedFiles) => {
    setFiles((prevFiles) => [...prevFiles].concat(acceptedFiles));
    const auxArr = [];
    const auxForm = [];
    acceptedFiles.forEach(async (item) => {
      auxArr.push(URL.createObjectURL(item));
    });
    const amigo = files.concat(acceptedFiles);
    amigo.forEach(async (item) => {
      auxForm.push(await toBase64(item));
    });
    setFieldValue(name, auxForm);
    setAux((prevImgs) => [...prevImgs].concat(auxArr));
    // eslint-disable-next-line
  };

  const handleRemoveAll = () => {
    setFiles([]);
    setAux([]);
    setFieldValue(name, []);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: handleDrop,
  });

  const handleRemoveSingleFile = (i) => {
    files.splice(i, 1);
    const auxForm = [];
    files.forEach(async (item) => {
      auxForm.push(await toBase64(item));
    });
    setFieldValue(name, auxForm);
    const newAux = aux.filter((item) => item !== aux[i]);
    setAux(newAux);
  };

  // const handleChange = async (file) => {
  //   const {
  //     field: { name }, form: { setFieldValue },
  //   } = this.props;
  //   if (file && file.length > 0) {
  //     setFieldValue(name, await toBase64(file[0]));
  //   }
  // }

  return (
    <div
      className={clsx(classes.root, className)}
      {...rest}
    >
      {limit && aux.length > limit && (
        <Alert
          severity="warning"
        >
          Recuerde que solo puede agregar {limit} imagenes
        </Alert>
      )}
      {limit && aux.length < limit && (
        <div
          className={clsx({
            [classes.dropZone]: true,
            [classes.dragActive]: isDragActive,
          })}
          {...getRootProps()}
        >
          <input {...getInputProps()} accept={accept} />
          <div>
            <img
              alt="Select file"
              className={classes.image}
              src="/static/images/undraw_add_file2_gvbb.svg"
            />
          </div>
          <div>
            <Typography
              gutterBottom
              variant="h3"
            >
              Seleccione las imágenes
            </Typography>
            <Box mt={2}>
              <Typography
                color="textPrimary"
                variant="body1"
              >
                Por favor seleccione las imágenes
              </Typography>
            </Box>
          </div>
        </div>
      )}
      {aux.length > 0 && (
        <>
          <div className={classes.container}>
            {aux.map((item, i) => (
              <div
                className={classes.imageContainer}
                key={`div-${String(i)}`}
              >
                {files[i].type === 'application/pdf' && (
                  <>
                    {/* eslint-disable-next-line */}
                    <iframe title="PDF preview" src={item} className={classes.images} />
                  </>
                )}
                {files[i].type === 'video/mp4' && (
                  <>
                    {/* eslint-disable-next-line */}
                    <video
                      className={classes.images}
                      controls
                    >
                      <source src={item} />
                    </video>
                  </>
                )}
                {files[i].type !== 'video/mp4' && files[i].type !== 'application/pdf' && (
                  <img
                    className={classes.images}
                    src={item}
                    alt="images"
                    key={`image-${String(i)}`}
                  />
                )}
                <Tooltip
                  title="Eliminar"
                  key={`tooltip-${String(i)}`}
                >
                  <IconButton
                    key={`icon-${String(i)}`}
                    edge="end"
                    onClick={() => handleRemoveSingleFile(i)}
                    className={classes.button}
                  >
                    <Trash
                      key={`trash-${String(i)}`}
                    />
                  </IconButton>
                </Tooltip>
              </div>
            ))}
          </div>
          <div className={classes.actions}>
            <Button
              onClick={handleRemoveAll}
              size="small"
            >
              Eliminar todas
            </Button>
          </div>
        </>
      )}
      {/* files.length > 0 && (
        <>
          <PerfectScrollbar options={{ suppressScrollX: true }}>
            <List className={classes.list}>
              {files.map((file, i) => (
                <ListItem
                  divider={i < files.length - 1}
                  key={String(i)}
                >
                  <ListItemIcon>
                    <FileCopyIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={file.name}
                    primaryTypographyProps={{ variant: 'h5' }}
                    secondary={bytesToSize(file.size)}
                  />
                  <Tooltip title="Más">
                    <IconButton edge="end" onClick={(e) => openPopover(e, i)}>
                      <MoreIcon />
                    </IconButton>
                  </Tooltip>
                </ListItem>
              ))}
            </List>
          </PerfectScrollbar>
          <div className={classes.actions}>
            <Button
              onClick={handleRemoveAll}
              size="small"
            >
              Eliminar todas
            </Button>
            <Button
              color="secondary"
              size="small"
              variant="contained"
            >
              Upload files
            </Button>
          </div>
        </>
      ) */}
    </div>
  );
}

ImageDropzone.propTypes = {
  className: PropTypes.string,
  field: PropTypes.shape(),
  form: PropTypes.shape(),
  accept: PropTypes.string,
  limit: PropTypes.number,
};

export default ImageDropzone;
